import { useAuthStore } from "../../stores/authStore";
import Dropdown from "../dropdown/dropdown";
import { useTranslation } from "react-i18next";

interface Language {
  id: string;
  label: string;
  disabled?: boolean;
}

function LanguageSelector() {
  const { i18n } = useTranslation();
  const { setLang } = useAuthStore();

  const currentLanguageCode = i18n.language;

  const languageLabels: { [key: string]: string } = {
    en: "English",
    es: "Español",
    ru: "Русский",
    ch: "中文"
  };

  const caption = languageLabels[currentLanguageCode];

  const handleLanguageChange = (selectedLanguage: Language): void => {
    i18n.changeLanguage(selectedLanguage.id);
    setLang(selectedLanguage.id);
  };

  const languageOptions: Language[] = [
    { id: "en", label: "English" },
    { id: "es", label: "Español", disabled: true },
    { id: "ru", label: "Русский" },
    { id: "ch", label: "中文", disabled: true },
  ];

  return (
    <>
      <Dropdown
        items={languageOptions}
        onSelect={handleLanguageChange}
        caption={caption}
      />
    </>
  );
}

export default LanguageSelector;
